import '../styles/Header.css';
import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';

const About = () => {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  return (
    <section className="about-section" id="about">
      <div className="about-container" data-aos="fade-up">
        <div className="about-text">
          <h2>About Us</h2>
          <p>
            At <strong>Cvey Solutions Private Limited</strong>, we believe in crafting innovative, efficient, and scalable tech solutions that transform businesses and empower users.Provides innovative solutions.
            <br /><br />
            Our team of dedicated professionals brings deep expertise in web development, AI integration, and enterprise IT services — helping our clients stay ahead in the digital age.
          </p>
        </div>
        <div className="map-container" data-aos="fade-up">
          <iframe title="Cvey Solutions Map" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3815.8741498593254!2d82.2195598313719!3d16.98073963370357!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a3829cba1df3645%3A0x526a54b738919d35!2sCVEY%20Solutions%20Private%20limited!5e0!3m2!1sen!2sin!4v1747551449789!5m2!1sen!2sin" width="600" height="300" style={{ border: 0, borderRadius: '12px' }} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
        </div>

      </div>
    </section>
  );
};

export default About;
